<template>
  <div
    v-if="isText"
    class="input-group-text"
  >
    <slot />
  </div>
  <slot v-else />
</template>

<script>
export default {
  name: 'BInputGroupPrepend',
  props: {
    isText: { type: Boolean, default: false },
  },
}
</script>
